import * as Sentry from '@sentry/vue';
import Vue from 'vue';
import router from '@/router';
// @ts-ignore
import { HttpClient } from '@sentry/integrations';

Sentry.init({
  Vue,
  dsn: import.meta.env.VITE_VUE_APP_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
    new HttpClient(),
  ],
  // This option is required for capturing headers and cookies.
  sendDefaultPii: true,
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export { Sentry };
